<template>
  <div class="settleAccounts" v-if="CloseState1">
    <div class="settleAccounts-center">
      <div class="settleAccounts-one">
        <img :src="closeImg" alt @click="onclickImg" />
      </div>
      <div class="settleAccounts-two">
        <p>一键结算</p>
        <img src="../../../assets/imgage/jiesuan_pic.png" alt />
      </div>
      <div class="settleAccounts-three">
        <div class="settleAccounts-three-left">
          <span>当前可结算金额</span>
          <span>{{ totalToBeSettleAmount }}</span>
        </div>
        <div class="settleAccounts-three-left" style="margin:20px 0;">
          <span>订单</span>
          <span>{{ orderNum }}个</span>
        </div>
        <div class="settleAccounts-three-left">
          <span>商品</span>
          <span>{{ goodsNum }}件</span>
        </div>
        <div class="settleAccounts-footer">
          <van-button
            class="settleAccounts-footer-button"
            v-preventReClick
            @click="onClickSumbit"
            >提交结算申请</van-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSupplierApply } from "api/index/api";
import { Toast } from "vant";
export default {
  props: {
    // CloseState: {},
    token: {}, //登陆token
    settleObj: {} // 一键结算数据
  },
  data() {
    return {
      CloseState1:true,
      closeImg: require("../../../assets/imgage/icon_close.png"),
      orderNum: null, //订单个数
      goodsNum: null, //商品件数
      totalToBeSettleAmount: null //待结算总额
    };
  },
  watch: {
    settleObj: function(newVal, oldVal) {
      this.orderNum = this.settleObj.orderNum;
      this.goodsNum = this.settleObj.goodsNum;
      this.totalToBeSettleAmount = this.settleObj.totalToBeSettleAmount;
    }
  },
  created() {},
  mounted() {},
  methods: {
    //关闭图片
    onclickImg() {
      this.$emit("onclickImg");
    },
    getSupplier() {
      let params = {
        Authorization: this.token
      };
      getSupplierApply(params).then(res => {
        Toast.success("提交成功");
      });
    },
    // 提交
    onClickSumbit() {
      this.$emit('onClickSumbit',this.CloseState1)
      // this.getSupplier();
    }
  }
};
</script>
<style lang="scss" scoped>
.settleAccounts {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  background: rgba(0, 0, 0, 0.5);
  .settleAccounts-center {
    background-image: url("../../../assets/imgage/withdrawal_bg.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-size: 100% 100%;
    width: 82%;
    height: 750px;
    position: fixed;
    left: 0;
    top: -200px;
    bottom: 0;
    right: 0;
    margin: auto;
    z-index: 999;
  }
  .settleAccounts-one {
    & > img {
      width: 24px;
      height: 24px;
      position: absolute;
      top: 32px;
      right: 40px;
    }
  }
  .settleAccounts-two {
    text-align: center;
    margin-top: 43px;
    & > p {
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
    & > img {
      width: 144px;
      height: 144px;
      margin-top: 29px;
    }
  }
  .settleAccounts-three {
    padding: 123px 34px 80px 34px;
  }
  .settleAccounts-three-left {
    display: flex;
    justify-content: space-between;
    & > span:nth-child(1) {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
    & > span:nth-child(2) {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
  }
  .settleAccounts-footer {
    text-align: center;
    margin-top: 80px;
    .settleAccounts-footer-button {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      background: #e84031;
      border-radius: 45px;
      padding: 23px 160px;
      // width: 88%;
      text-align: center;
      margin: 0 auto;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/completeRecords/orderForm/settleAccounts.vue